import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

export default function CTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const items = section.querySelectorAll('.cta-animate');
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        once: true,
      },
    });

    tl.fromTo(
      items,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, stagger: 0.1, ease: 'power3.out' }
    );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="cta"
      style={{ background: '#0F1923', padding: '100px 0' }}
    >
      <div className="mx-auto max-w-[800px] px-6 text-center">
        <h2
          className="cta-animate font-display font-semibold opacity-0"
          style={{ fontSize: 'clamp(32px, 4.5vw, 52px)', lineHeight: 1.1, color: '#FFFFFF' }}
        >
          Start Researching Land Parcels Within Minutes
        </h2>

        <p
          className="cta-animate mx-auto mt-5 font-body opacity-0"
          style={{
            fontSize: 17,
            lineHeight: 1.6,
            color: 'rgba(255,255,255,0.9)',
            maxWidth: 560,
          }}
        >
          No retainer. No commitment. Access parcel data, ownership records, and zoning information immediately.
        </p>

        {/* Trust line */}
        <div className="cta-animate mt-6 flex flex-wrap items-center justify-center gap-4 opacity-0">
          <span className="flex items-center gap-1.5 text-xs font-medium" style={{ color: 'rgba(255,255,255,0.8)' }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M11.5 3L5.5 9.5L2.5 6.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Cancel anytime
          </span>
          <span className="flex items-center gap-1.5 text-xs font-medium" style={{ color: 'rgba(255,255,255,0.8)' }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M11.5 3L5.5 9.5L2.5 6.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            1-week free trial on all plans
          </span>
          <span className="flex items-center gap-1.5 text-xs font-medium" style={{ color: 'rgba(255,255,255,0.8)' }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M11.5 3L5.5 9.5L2.5 6.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Money-back guarantee
          </span>
        </div>

        {/* Two buttons */}
        <div className="cta-animate mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row opacity-0">
          <Link
            to="/register"
            className="plp-btn-primary !px-10 !py-4 !text-sm"
          >
            Get Started
          </Link>
          <a
            href="#sample-report"
            className="plp-btn-secondary !px-10 !py-4 !text-sm"
          >
            See Sample Lead
          </a>
        </div>
      </div>
    </section>
  );
}
